import React from 'react';
import type { MuiFileInputProps } from 'mui-file-input';
import { MuiFileInput } from 'mui-file-input';
import { Controller } from 'react-hook-form';
import type { Control, FieldValues } from 'react-hook-form';

type IFileInputProps<TFieldValues extends FieldValues> = {
  name: any;
  control: Control<TFieldValues>;
} & MuiFileInputProps;

const FileInput = <TFieldValues extends FieldValues>(props: IFileInputProps<TFieldValues>) => {
  const { control, name } = props;

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value, ...field }, fieldState }) => (
        <MuiFileInput
          {...props}
          {...field}
          value={value?.name ? value : null}
          onChange={(file) => {
            console.log("Selected file:", file);
            onChange(file); // Update form state
          }}
          helperText={fieldState.invalid ? 'File is invalid' : ''}
          error={fieldState.invalid}
        />
      )}
    />
  );
};

export default FileInput;


